

























import {
  defineComponent,
  computed,
  ComputedRef,
  ref,
  PropType
} from '@nuxtjs/composition-api';
import { StatusReference } from '@/helpers/utils';
import type { LabelVariantType } from '~/components/atoms/KELabel.vue';

export default defineComponent({
  name: 'Availability',
  props: {
    statusReference: {
      type: Number as PropType<StatusReference>,
      default: StatusReference.IN_STOCK
    },
    product: {
      type: Object,
      required: true
    },
    status: {
      type: String,
      default: 'Op voorraad'
    },
    statusSubtext: {
      type: String,
      default: ''
    },
    stockClassificationCode: {
      type: String
    }
  },
  setup(props) {
    const labelVariant: ComputedRef<LabelVariantType> = computed(() => {
      if (
        [
          StatusReference.ON_ORDER,
          StatusReference.PRE_ORDER,
          StatusReference.TEMPORARILY_SOLD_OUT
        ].includes(props.statusReference)
      ) {
        return 'soon-available';
      }
      if (props.product?.can_be_ordered === false) {
        return 'not-available';
      }
      return 'available';
    });

    const isDrawerOpen = ref(false);

    const handleAvailabilityClick = () => {
      isDrawerOpen.value = true;
    };

    return {
      labelVariant,
      isDrawerOpen,
      handleAvailabilityClick
    };
  }
});
